export default "__VITE_ASSET__BmOkVNF7__"